import Logger from "@/utils/logger";

import { TTab, TTabConfig } from "./types";

/**
 * Validates that all tab titles are unique.
 *
 * @template T - Union type of valid tab titles
 * @param tabs - Array of tab configurations to validate
 */
export const validateUniqueTabTitles = <T extends string>(tabs: TTab<T>[]): void => {
  if (import.meta.env.DEV) {
    const tabNames = tabs.map((t) => t.title);
    const duplicates = tabNames.filter((tabName, i) => tabNames.indexOf(tabName) !== i);

    if (duplicates.length > 0) {
      Logger.error('validateUniqueTabTitles', 'Duplicate tab title found:',duplicates.join(', '));
      throw Error('Duplicated tab titles found.')
    }
  }
};

/**
 * Converts a tab configuration record into an array of Tab objects.
 * Ensures type safety by requiring all tab titles to be defined in the config.
 *
 * @template T - Union type of valid tab titles (must extend string)
 * @param config - Record mapping each tab title to its configuration
 * @returns Array of Tab objects ready for the Tabs component
 */

export const createTabsFromConfig = <T extends string>(config: TTabConfig<T>): TTab<T>[] => {
  return (Object.keys(config) as T[]).map((title) => ({
    title,
    ...config[title],
  }));
};